import { ISearchPreFiltersConfig } from '@shared/components/SearchPreFilters';

export const searchPreFiltersConfig: ISearchPreFiltersConfig = {
  tabs: [
    {
      title: 'HELMETS',
      collectionHandles: ['amx-categories-helmets'],
      sections: [
        {
          name: 'helmetRidingStyle',
          label: 'RIDING STYLE',
          facetField: 'meta.plytix.amx_riding_type',
          queryParam: 'ridingTypes',
        },
        {
          name: 'helmetAge',
          label: 'AGE',
          facetField: 'meta.plytix.amx_age',
          queryParam: 'ages',
        },
        {
          name: 'helmetSafetyRating',
          label: 'SAFETY RATING',
          facetField: 'meta.plytix.amx_safety_rating',
          queryParam: 'safetyRatings',
        },
        {
          name: 'helmetMaterial',
          label: 'MATERIAL',
          facetField: 'meta.plytix.material',
          queryParam: 'materials',
        },
      ],
    },
    {
      title: 'RIDING GEAR',
      collectionHandles: [
        'amx-categories-road',
        'amx-categories-adventure',
        'amx-categories-off-road',
      ],
      sections: [
        {
          name: 'gearRidingStyle',
          label: 'RIDING STYLE',
          facetField: 'meta.plytix.amx_riding_type',
          queryParam: 'ridingTypes',
        },
        {
          name: 'gearAge',
          label: 'AGE',
          facetField: 'meta.plytix.amx_age',
          queryParam: 'ages',
        },
        {
          name: 'gearGender',
          label: 'GENDER',
          facetField: 'meta.plytix.amx_gender',
          queryParam: 'genders',
        },
        {
          name: 'gearSafetyRating',
          label: 'SAFETY RATING',
          facetField: 'meta.plytix.amx_safety_rating',
          queryParam: 'safetyRatings',
        },
        {
          name: 'gearMaterial',
          label: 'MATERIAL',
          facetField: 'meta.plytix.material',
          queryParam: 'materials',
        },
      ],
    },
    {
      title: 'BOOTS',
      collectionHandles: [
        'amx-categories-off-road-boots',
        'amx-categories-adventure-adventure-boots',
        'amx-categories-road-mens-road-gear-boots',
        'amx-categories-road-womens-road-gear-boots',
      ],
      sections: [
        {
          name: 'bootRidingStyle',
          label: 'RIDING STYLE',
          facetField: 'meta.plytix.amx_riding_type',
          queryParam: 'ridingTypes',
        },
        {
          name: 'bootAge',
          label: 'AGE',
          facetField: 'meta.plytix.amx_age',
          queryParam: 'ages',
        },
        {
          name: 'bootGender',
          label: 'GENDER',
          facetField: 'meta.plytix.amx_gender',
          queryParam: 'genders',
        },
        {
          name: 'bootSafetyRating',
          label: 'SAFETY RATING',
          facetField: 'meta.plytix.amx_safety_rating',
          queryParam: 'safetyRatings',
        },
        {
          name: 'bootMaterial',
          label: 'MATERIAL',
          facetField: 'meta.plytix.material',
          queryParam: 'materials',
        },
      ],
    },
  ],
  priceFilter: {
    minOptions: [
      { label: 'Any', value: null },
      { label: '$0', value: 0 },
      { label: '$50', value: 50 },
      { label: '$100', value: 100 },
      { label: '$200', value: 200 },
      { label: '$500', value: 500 },
      { label: '$1000', value: 1000 },
    ],
    maxOptions: [
      { label: 'Any', value: null },
      { label: '$100', value: 100 },
      { label: '$200', value: 200 },
      { label: '$500', value: 500 },
      { label: '$1000', value: 1000 },
      { label: '$2000', value: 2000 },
      { label: '$5000', value: 5000 },
    ],
  },
};
